define('modularisBase/debug',
   ['jquery', 'kendo', 'clientCache', 'configLoader', 'logger'],
   function ($, kendo, clientCache, configLoader, logger) {
       'use strict';
       var eventHandlers = {};

       var displayObject = function (object) {

           for (var property in object) {
               if (object.hasOwnProperty(property)) {
                   if (object === eventHandlers) {
                       logger.info('Name:', property + '. Count:', object[property]);
                   } else {
                       logger.info(property + ':', object[property]);
                   }
               }
           }

       };

       /**
          * Helper with functions to help developers to debug the web application.
          * @namespace debug
          * @memberof modularis
          */
       var debug = {

         /**
         * Indicates whether the debug is enable or not.
         * 
         * @memberOf modularis.debug
         * 
         * @return {boolean}
         */
           isEnabled: function () {
               return configLoader.appConfig && configLoader.appConfig.debug.enabled;
           },

         /**
         * Registers a handler for an event.
         * 
         * @memberOf modularis.debug
         * 
         * @param {string} eventName - The event name to register.
         */
           registerEventHandler: function (eventName) {

               if (!(eventName in eventHandlers)) {
                   eventHandlers[eventName] = 1;
               } else {
                   eventHandlers[eventName] += 1;
               }
           },

         /**
         * Unregisters a handler for an event.
         * 
         * @memberOf modularis.debug
         * 
         * @param {string} eventName - The event name to unregister.
         */
           unregisterEventHandler: function (eventName) {
               if (!(eventName in eventHandlers)) {
                   eventHandlers[eventName] = 0;
               } else {
                   if (eventHandlers[eventName] > 0) {
                       eventHandlers[eventName] -= 1;
                   } else {
                       eventHandlers[eventName] = 0;
                   }
               }
           },

         /**
         * Shows the information of {@link modularis.debug.getBrowserData|the browser}, {@link modularis.debug.getWebStackData|web stack} and {@link modularis.debug.getEventsData|event handlers} in the console.
         * 
         * @memberOf modularis.debug
         * 
         */
           displayAllData: function () {

               var that = this;

               logger.info(new Date());
               logger.info('Browser information.');
               logger.info('--------------------------------------');
               var browserData = that.getBrowserData();
               displayObject(browserData);

               logger.info('WebStack information.');
               logger.info('--------------------------------------');
               var webStackData = that.getWebStackData();
               displayObject(webStackData);

               logger.info('Events handlers information.');
               logger.info('--------------------------------------');
               var eventsData = that.getEventsData();
               displayObject(eventsData);

           },

            /**
             * Returns the events handler information.
             * 
             * @memberOf modularis.debug
             * 
             * @return {Object} Plain key|value object where the key are the event names and the values the number of times that the event has been registered.
             */
           getEventsData: function () {

               return eventHandlers;
           },

           /**
             * Returns the browser information.
             * 
             * @memberOf modularis.debug
             * 
             * @return {Object} Plain key|value object with the next browser information: BrowserName, CookiesEnabled, URL, UserAgent and Version.
             * if the flag kendo.support.mobileSO is true, then this object will include the next extra information: MobileDevice, IsTablet, MajorBrowserVersion and MinorBrowserVersion.
             */
           getBrowserData: function () {

               var name = null;
               var browser = kendo.support.browser;
               if (browser.msie) {
                   name = 'Internet Explorer';
               } else if (browser.mozilla) {
                   name = 'Mozilla Firefox';
               } else if (browser.opera) {
                   name = 'Opera';
               } else if (browser.webkit && browser.chrome) {
                   name = 'Google Chrome';
               } else if (browser.webkit && browser.safari) {
                   name = 'Safari';
               }

               var browserData = {
                   BrowserName: name,
                   CookiesEnabled: window.navigator.cookieEnabled,
                   URL: window.location.href,
                   UserAgent: window.navigator.userAgent,
                   Version: browser.version
               };

               if (kendo.support.mobileOS) {

                   browserData.MobileDevice = kendo.support.mobileOS.device;
                   browserData.IsTablet = kendo.support.mobileOS.tablet;
                   browserData.BrowserName = kendo.support.mobileOS.browser;
                   browserData.MajorBrowserVersion = kendo.support.mobileOS.majorVersion;
                   browserData.MinorBrowserVersion = kendo.support.mobileOS.minorVersion;
               }
               return browserData;
           },

           /**
             * Returns the web stack information.
             * 
             * @memberOf modularis.debug
             * 
             * @return {Object} Plain key|value object with the next web stack information: jQueryVersion, KendoVersion, SystemName, ActiveServerName, ActiveServerPrimaryURI, UIDefID, DeviceName, SessionID (if extist) and UserName (if exist).
             */
           getWebStackData: function () {

               var activeServer = clientCache.getActiveServer();

               var stackData = {
                   jQueryVersion: $.fn.jquery,
                   KendoVersion: kendo.version,
                   //ModularisVersion: modularisApp.version,
                   SystemName: configLoader.appConfig.systemName,
                   ActiveServerName: activeServer.name,
                   ActiveServerPrimaryURI: activeServer.primaryURI,
                   UIDefID: clientCache.getUIDefID(),
                   DeviceName: clientCache.getDeviceName()
               };

               var sessionID = clientCache.getSessionID();
               if (sessionID) {
                   stackData.SessionID = sessionID;
               }

               if (clientCache.getSession() && clientCache.getSession().User) {
                   stackData.Username = clientCache.getSession().User.Username;
               }

               return stackData;

           }

       };

       return debug;

   }
);
